import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLanguage } from '../App';

function Terms() {
  const { t } = useLanguage();
  const sections = t.terms.sections;

  return (
    <div className="page-content">
      <Helmet>
        <title>Chefyz - {t.terms.title}</title>
        <meta name="description" content={t.terms.intro} />
        <meta property="og:title" content={`Chefyz - ${t.terms.title}`} />
        <meta property="og:description" content={t.terms.intro} />
      </Helmet>
      <div className="page-header">
        <div className="container">
          <h1>{t.terms.title}</h1>
          <p>{t.terms.lastUpdated}: 1 Ocak 2025</p>
        </div>
      </div>

      <div className="page-body">
        <div className="container">
          <div className="legal-content">
            <div className="legal-intro">
              {t.terms.intro}
            </div>

            {Object.entries(sections).map(([key, section]) => (
              <div key={key} className="legal-section">
                <h2>{section.title}</h2>
                <p>{section.content}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Terms;
